export default {
  methods: {
    getSearchEntity: (criteria) => {
      let type = null;
      criteria = criteria.trim();
      const it = {
        /* TODO: if search by other fields than email/device/alarm is implemented  PLC Request for profile only devices
         *  (i.e not found in DR) must be adapted since it use the mac address from the search input as old_device_id
         *  */
        isEmail: criteria.match(/^[^"(),:;<>@[\]]+@.+\.\w{1,12}$/),
        isDevice: criteria.match(/^[a-f0-9]{12}$/i),
        isSerialNumber: criteria.match(/^[a-z0-9]{16}$/i),
        isAlarm: criteria.match(/^[a-f0-9]{10}$/i),
        isCusRequest: criteria.match(/^plc\w{4}-\w{4}$/i),
        isCusRequestGroup: criteria.match(/^plc\w{8}-\w{8}$/i),
        isOrder: criteria.match(/^([0-9]+-)+([0-9]+)$/),
        isPhone: false,
        // isPhone: criteria.match(/^\+\s\d{8,12}$/) TODO: take it back when it be implemented in the Server
      };
      if (it.isCusRequest) {
        type = "plc-uuid";
      } else if (it.isCusRequestGroup) {
        type = "plc-gid";
      } else if (it.isEmail || it.isPhone) {
        type = "Customer";
      } else if (it.isDevice) {
        type = "Device";
      } else if (it.isAlarm) {
        type = "Alarm";
      } else if (it.isSerialNumber) {
        type = "DSN";
      } else if (it.isOrder) {
        type = "order";
      } else if (criteria === "") {
        type = "";
      } else {
        type = "Unknown";
      }
      return type;
    },
  },
};
